import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/landing'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js